import { render, staticRenderFns } from "./CourseVideo.vue?vue&type=template&id=35a7df89&scoped=true&"
import script from "./CourseVideo.vue?vue&type=script&lang=js&"
export * from "./CourseVideo.vue?vue&type=script&lang=js&"
import style0 from "./CourseVideo.vue?vue&type=style&index=0&id=35a7df89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a7df89",
  null
  
)

export default component.exports